import styled from 'styled-components'

export const ParticipantsContainer = styled.div`
    margin: 0;
    padding: 5vh;
    background-size: cover;
    background-repeat: no-repeat;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(40vw, 1fr));
    gap: 5vh;
    z-index: 10;

`

export const ParticipantsH1 = styled.h1`
    background-color: black;
    color: #fff;
    text-align: center;
    margin: 0;
    padding: 3vh;
`;